import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { BrandBuilder } from '../../models/builders/brand.builder';

@Injectable()
export class BrandApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${environment.apiUrl}brands`;
  }

  getBrands() {
    return this.httpClient.get(this.apiUrl).pipe(map(BrandBuilder.fromJsonList));
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/api/brand-api.service.ts